import { render, staticRenderFns } from "./SummaryReportBasedOnLiabilities.vue?vue&type=template&id=dd256102&"
import script from "./SummaryReportBasedOnLiabilities.vue?vue&type=script&lang=js&"
export * from "./SummaryReportBasedOnLiabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports